import { CaseRemarksResult } from "../models/tr-cr-lookup/case-remarks";
import { CaseDocketResult } from "../models/tr-cr-lookup/case-docket";
import { CaseStatusResult } from "../models/tr-cr-lookup/case-status";
import { CaseSummaryResult } from "../models/tr-cr-lookup/case-summary";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { courtConnectBaseUrl } from "./connect-api";
import { CaseBalanceResult } from "../models/tr-cr-lookup/case-balance";
import { CasePaymentsResult } from "../models/tr-cr-lookup/case-payments";
import { CasePriorsResult } from "../models/tr-cr-lookup/case-priors";
import { CaseAkaResult } from "../models/tr-cr-lookup/case-aka";
import { CaseAttachmentsResult } from "../models/tr-cr-lookup/case-attachments";
import { CaseDetailResult } from "../models/tr-cr-lookup/case-detail";
import { CivilSummaryResult } from "../models/civil-lookup/civil-case-summary";
import { CivilCaseStatusResult } from "../models/civil-lookup/civil-case-status";
import { CivilCaseDocketResult } from "../models/civil-lookup/civil-case-docket";
import { CivilCaseJudgmentResult } from "../models/civil-lookup/civil-case-judgement";
import { CivilCasePlantiffResult } from "../models/civil-lookup/civil-plaintiff-result";
import { CivilCaseDefendantResult } from "../models/civil-lookup/civil-defendant-result";

export const globalApi = createApi({
  reducerPath: "globalApi",
  baseQuery: fetchBaseQuery({
    baseUrl: courtConnectBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS");
      return headers;
    }
  }),
  endpoints: (builder) => ({
    lookupCase: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseLookup"
      })
    }),
    getCaseSummary: builder.mutation<CaseSummaryResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseSummary"
      })
    }),
    getCaseStatus: builder.mutation<CaseStatusResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseStatus"
      })
    }),
    getCaseDocket: builder.mutation<CaseDocketResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseDocket"
      })
    }),
    getCaseRemarks: builder.mutation<CaseRemarksResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseRemarks"
      })
    }),
    getCaseBalances: builder.mutation<CaseBalanceResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseBalance"
      })
    }),
    getCaseViolationDetails: builder.mutation<CaseDetailResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseDetail"
      })
    }),
    getCasePayments: builder.mutation<CasePaymentsResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CasePayments"
      })
    }),
    getCasePriors: builder.mutation<CasePriorsResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CasePriors"
      })
    }),
    getCaseAka: builder.mutation<CaseAkaResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseAKA"
      })
    }),
    getCaseAttachments: builder.mutation<CaseAttachmentsResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CaseAttachment"
      })
    }),
    postPayment: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "Authorize"
      })
    }),
    getPaymentConfig: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "PaymentConfig"
      })
    }),
    postInfintechPayment: builder.mutation({
      query: (paymentRequest) => ({
        method: "POST",
        body: paymentRequest,
        url: "Infintech"
      })
    }),
    prePaymentInsert: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "InsertPrePayment"
      })
    }),
    postPaymentInsert: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "InsertPaymentPostBack"
      })
    }),
    civilCaseLookup: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCaseLookup"
      })
    }),
    civilCaseSummary: builder.mutation<CivilSummaryResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCaseSummary"
      })
    }),
    civilCaseStatus: builder.mutation<CivilCaseStatusResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCaseStatus"
      })
    }),
    civilCaseDocket: builder.mutation<CivilCaseDocketResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCaseDocket"
      })
    }),
    civilCaseJudgement: builder.mutation<CivilCaseJudgmentResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCaseJudgment"
      })
    }),
    civilCasePlaintiff: builder.mutation<CivilCasePlantiffResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCasePlantiff"
      })
    }),
    civilCaseDefendant: builder.mutation<CivilCaseDefendantResult, unknown>({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "CivilCaseDefendant"
      })
    }),
    prePaymentCivilInsert: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "InsertCivilPrePayment"
      })
    }),
    postPaymentCivilInsert: builder.mutation({
      query: (lookupRequest) => ({
        method: "POST",
        body: lookupRequest,
        url: "InsertCivilPaymentPostBack"
      })
    }),
    verifyCaptcha: builder.mutation({
      query: (token) => ({
        url: "HCaptcha",
        method: "POST",
        body: { token }
      })
    }),
    getAllConfigs: builder.query({
      query: (request) => ({
        url: "CourtConnectConfig",
        method: "POST",
        body: request
      })
    }),
    InsertPaymentPostBack: builder.mutation({
      query: (request) => ({
        url: "InsertPaymentPostBack",
        method: "POST",
        body: request
      })
    })
  })
});

export const {
  useLookupCaseMutation,
  useGetCaseSummaryMutation,
  useGetCaseStatusMutation,
  useGetCaseDocketMutation,
  useGetCaseRemarksMutation,
  useGetCaseBalancesMutation,
  useGetCaseViolationDetailsMutation,
  useGetCasePaymentsMutation,
  useGetCasePriorsMutation,
  useGetCaseAkaMutation,
  useGetCaseAttachmentsMutation,
  usePostPaymentMutation,
  usePrePaymentInsertMutation,
  usePostPaymentInsertMutation,
  usePostInfintechPaymentMutation,
  useCivilCaseLookupMutation,
  useCivilCaseSummaryMutation,
  useCivilCaseStatusMutation,
  useCivilCaseDocketMutation,
  useCivilCaseJudgementMutation,
  useCivilCasePlaintiffMutation,
  useCivilCaseDefendantMutation,
  useVerifyCaptchaMutation,
  useGetPaymentConfigMutation,
  usePrePaymentCivilInsertMutation,
  usePostPaymentCivilInsertMutation,
  useGetAllConfigsQuery,
  useInsertPaymentPostBackMutation
} = globalApi;
